import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import g from "./iconfont.es5471.js";
const d = {
  display: "block"
}, h = ({ size: t = 16, useVw: e, useRem: c, color: o, withColor: l, removeClassName: n, disableSSR: m, style: r, ...p }) => {
  const x = r ? { ...d, ...r } : d;
  return /* @__PURE__ */ a.createElement(g, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-bangzhuzhongxin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: e ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), height: e ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (c ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: n ? "" : "24px-å¸®å©ä¸­å¿"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: n ? "" : "normal",
        fill: l ? i(o, 0, "#262933") : "#262933",
        datafollowfill: l ? i(o, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M11.997 3.3a8.7 8.7 0 1 0 4.539 16.124.8.8 0 0 1 .835 1.364 10.255 10.255 0 0 1-5.374 1.512c-5.689 0-10.3-4.611-10.3-10.3 0-5.688 4.611-10.3 10.3-10.3 5.689 0 10.3 4.612 10.3 10.3a10.271 10.271 0 0 1-1.512 5.375.8.8 0 1 1-1.364-.836A8.671 8.671 0 0 0 20.697 12a8.7 8.7 0 0 0-8.7-8.7Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M11.55 15.627a1 1 0 1 1 1.415 1.414 1 1 0 0 1-1.414-1.414ZM9.974 7.92c.593-.522 1.398-.815 2.238-.815.84 0 1.644.293 2.238.816.593.522.927 1.23.927 1.969 0 1.097-.394 1.673-1.404 2.562l-.156.14c-.587.534-.742.803-.742 1.35 0 .2-.09.394-.253.536a.927.927 0 0 1-.61.223.927.927 0 0 1-.61-.223.717.717 0 0 1-.253-.537c0-1.097.393-1.673 1.404-2.562l.155-.14c.587-.534.742-.803.742-1.349 0-.336-.151-.658-.42-.895a1.544 1.544 0 0 0-1.018-.371c-.382 0-.748.133-1.017.37-.27.238-.422.56-.422.896l-.008.103a.743.743 0 0 1-.31.486.944.944 0 0 1-.604.169.915.915 0 0 1-.572-.24.713.713 0 0 1-.232-.518c0-.739.333-1.447.927-1.97Z"
        }
      )
    )
  )));
}, k = h;
export {
  k as default
};
